export default __webpack_public_path__ + "static/media/instalation.9e153100.svg";